import { gql, useLazyQuery } from '@apollo/client';

export const IS_ZIPCODE_IN_HUB_AREAS = gql`
  query IsZipcodeInHubAreas($zipcode: String!) {
    isZipcodeInHubAreas(zipcode: $zipcode)
  }
`;

export interface IsZipcodeInHubAreasResponse {
  isZipcodeInHubAreas: boolean;
}

export interface IsZipcodeInHubAreasVariables {
  zipcode: string;
}

export const useIsZipcodeInHubAreas = () => {
  return useLazyQuery<IsZipcodeInHubAreasResponse, IsZipcodeInHubAreasVariables>(
    IS_ZIPCODE_IN_HUB_AREAS
  );
};

